import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap'

const meta = document.createElement('meta');
meta.httpEquiv = 'Content-Security-Policy';
meta.content = "frame-ancestors 'self' *"; // Permite iframes de qualquer origem
document.head.appendChild(meta);

const app = createApp(App)

app
  .use(router)
  .mount('#app')
